import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {SERVICE_CONFIG, TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {UtilsModule} from '../../utils/utils.module';
import {NgxPermissionsService} from 'ngx-permissions';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'nf-task-button',
  templateUrl: './task-button.component.html',
  styleUrls: ['./task-button.component.css']
})
export class TaskButtonComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  auditItemIdList = [];
  monitorItemIdList = [];
  taskReportConfig: any;
  auditModalVisible = false;
  monitorModalVisible = false;
  auditList: any  = []; // 稽核列表
  monitorList: any  = []; // 监控列表
  checkVisible = false; // 检查项详情
  checkMonitorVisible = false;
  // 稽核来源
  outSystems: any = {
    yhfin: '赢和'
  };
  reportVisible = false;
  taskDataDate: string;
  permissionDefinition: any;
  currentUser: any; // 存放当前用户信息
  scanAuditTimer: any; // 扫描轮询
  scanMonitorTimer: any; // 扫描轮询
  currentAuditStatus = 'in_progress';
  scanAuditStatus = false; // 稽核扫描状态
  scanMonitorStatus = false; // 监控扫描状态
  @ViewChild('checkList') checkList;
  @ViewChild('ratioSuperisory') ratioSuperisory: any;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      this.currentUser = data.boardData.currentUser;
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  @Input('nfPermissionDefinition') set ChangePermissionDefinition(data: any) {
    this.permissionDefinition = data;
    this.permissionsService.loadPermissions(this.currentUser.permissions ? this.currentUser.permissions : []);
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private util: UtilsModule,
    private datePipe: DatePipe,
    private permissionsService: NgxPermissionsService
  ) { }

  ngOnInit(): void {
    if (this.pulse.taskDef) {
      if (this.pulse.taskDef.auditItemIdList) {
        this.auditItemIdList = this.pulse.taskDef.auditItemIdList;
      }
      if (this.pulse.taskDef.monitorItemIdList) {
        this.monitorItemIdList = this.pulse.taskDef.monitorItemIdList;
      }
      if (this.pulse.taskDef.taskReportConfig) {
        this.taskReportConfig = this.pulse.taskDef.taskReportConfig;
      }
    }
    this.taskDataDate = localStorage.getItem('taskDataDate');
  }
  // 刷新稽核
  refreshAudit(event?, id?) {
    if (event) {
      event.stopPropagation();
    }
    let idList = this.auditItemIdList.join(',');
    const param = {
      itemIdList: this.auditItemIdList,
      dataDate: this.taskDataDate,
      reloadData: '1'
    };
    if (id) {
      param.itemIdList = [id];
      idList = id;
    }
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      // 当天取稽核后台日期
      this.taskService.getRefreshTodayAuditDate({idList: idList}).subscribe((res: any) => {
        if (res) {
          const paramArr = [];
          for (const i in res) {
            if (res.hasOwnProperty(i) && res[i]) {
              this.refreshTodayAudit(i, res[i]);
              const _param = {
                itemIdList: [i],
                dataDate: res[i],
                reloadData: '1'
              };
              paramArr.push(_param);
            }
          }
          this.postBoardPulseScanLogData(this.taskDataDate, this.pulse.id, {auditItemList: paramArr});
        }
      });
    } else {
      // 查询历史稽核日期
      this.taskService.getBoardPulseScanLog(this.pulse.id, this.taskDataDate).subscribe((res: any) => {
        if (res && res.scanParam) {
          const scanParam = JSON.parse(res.scanParam);
          const auditItemList = scanParam.auditItemList;
          if (auditItemList && auditItemList.length) {
            this.taskService.refreshAuditStatus(auditItemList[0]).subscribe(res => {
              this.message.create('success', '稽核刷新成功！');
            });
          }
        }
      });
    }
    // this.taskService.refreshAuditStatus(param).subscribe(res => {
    //   this.message.create('success', '稽核刷新成功！');
    // });
  }
  // 轮询扫描状态
  pollingScanStatus() {
    this.scanAuditTimer = setInterval( () => {
      console.log('轮询中');
      if (this.pulse.columnValues[this.column.id] && this.pulse.columnValues[this.column.id].scanStatus === 'success') {
        this.scanMonitorStatus = false;
        this.scanAuditStatus = false;
        clearInterval(this.scanAuditTimer);
      }
    }, 3000);
  }
  // 当天刷新稽核
  refreshTodayAudit(id, dataDate) {
    this.scanAuditStatus = true;
    this.pollingScanStatus();
    const _param = {
      itemIdList: [id],
      dataDate: dataDate,
      reloadData: '1'
    };
    this.taskService.refreshAuditStatus(_param).subscribe(res => {
      // if (this.currentAuditStatus === 'in_progress') {
      //   this.scanAuditTimer = setInterval( () => {
      //     this.getAuditProgress(id, res[0].latestExecutionId);
      //   }, 3000);
      // } else {
      //   clearInterval(this.scanAuditTimer);
      // }
      this.message.create('success', '稽核刷新成功！');
    });
  }
  // 保存刷新稽核监控记录
  postBoardPulseScanLogData(date, pulseId, param) {
    const params = {
      scanDate: date,
      pulseId: pulseId,
      scanParam: param
    };
    this.taskService.postBoardPulseScanLog(params).subscribe(res => {});
  }
  // 刷新监控
  refreshMonitor(event?, id?) {
    if (event) {
      event.stopPropagation();
    }
    let idList = this.monitorItemIdList.join(',');
    const param = {
      itemIdList: this.monitorItemIdList,
      dataDate: this.taskDataDate,
      reloadData: '1'
    };
    if (id) {
      param.itemIdList = [id];
      idList = id;
    }
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      // 当天取监控后台日期
      this.taskService.getRefreshTodayIndicatorDate({idList: idList}).subscribe((res: any) => {
        if (res) {
          const paramArr = [];
          for (const i in res) {
            if (res.hasOwnProperty(i) && res[i]) {
              this.refreshTodayMonitor(i, res[i]);
              const _param = {
                itemIdList: [i],
                dataDate: res[i],
                reloadData: '1'
              };
              paramArr.push(_param);
            }
          }
          this.postBoardPulseScanLogData(this.taskDataDate, this.pulse.id, {indicatorItemList: paramArr});
        }
      });
    } else {
      // 查询历史监控日期
      this.taskService.getBoardPulseScanLog(this.pulse.id, this.taskDataDate).subscribe((res: any) => {
        if (res && res.scanParam) {
          const scanParam = JSON.parse(res.scanParam);
          const indicatorItemList = scanParam.indicatorItemList;
          if (indicatorItemList && indicatorItemList.length) {
            this.taskService.refreshMonitorStatus(indicatorItemList[0]).subscribe(res => {
              this.message.create('success', '监控刷新成功！');
            });
          }
        }
      });
    }
    // this.taskService.refreshMonitorStatus(param).subscribe(res => {
    //   this.message.create('success', '监控刷新成功！');
    // });
  }
  // 当天刷新监控
  refreshTodayMonitor(id, dataDate) {
    this.scanMonitorStatus = true;
    this.pollingScanStatus();
    const _param = {
      itemIdList: [id],
      dataDate: dataDate,
      reloadData: '1'
    };
    this.taskService.refreshMonitorStatus(_param).subscribe(res => {
      this.message.create('success', '监控刷新成功！');
    });
  }
  // 查看稽核结果
  auditResults() {
    this.auditModalVisible = true;
    this.getAuditResult();
  }
  // 查看监控结果
  monitorResults() {
    this.monitorModalVisible = true;
    this.getIndicatorResult();
  }
  // 稽核检查项查看
  openDetail(data) {
    if (!data.latestExecutionId) { return; }
    this.checkVisible = true;
    this.checkList.executionId = data.latestExecutionId;
    this.checkList.isQueryCollapsed = true;
    this.checkList.params = {};
    // this.checkList.setCondition();
    this.checkList.getColumsList();
    this.checkList.getTotal();
    this.checkList.listenerScroll();
  }
  // 稽核检查项详情-取消
  checkCancle() {
    this.checkList.show = false;
    this.checkVisible = false;
    this.checkList.emptyForm();
  }
  checkMonitorCancle() {
    this.checkMonitorVisible = false;
    this.ratioSuperisory.emptyForm();
  }
  // 监控检查项查看
  openMonitorDetail(data) {
    if (!data.latestExecutionId) { return; }
    this.checkMonitorVisible = true;
    this.ratioSuperisory.datasourceId = data.datasourceId;
    this.ratioSuperisory.executionId = data.latestExecutionId;
    this.ratioSuperisory.warnedComponent.executionId = data.latestExecutionId; // 获取执行id
    this.ratioSuperisory.isQueryCollapsed = true;
    this.ratioSuperisory.params = {};
    this.ratioSuperisory.itemId = data.id;

    this.ratioSuperisory.source = data.source;
    this.ratioSuperisory.outSystemCode = data.outSystem;
    this.ratioSuperisory.outItemId = data.outItemId;

    this.ratioSuperisory.getColumsList();
    this.ratioSuperisory.getTotal();
    this.ratioSuperisory.listenerScroll();
    this.ratioSuperisory.getTemplate();
  }
  // 导出excel
  exportExcel() {
    this.checkList.exportHandle();
  }
  // 获取稽核项状态
  getAuditResult() {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      this.taskService.getRefreshTodayAuditDate({idList: this.auditItemIdList.join(',')}).subscribe((res: any) => {
        let _date: any;
        if (res) {
          for (const i in res) {
            _date = res[i];
          }
          const param = {
            itemIdList: this.auditItemIdList,
            dataDate: _date
          };
          this.taskService.getAuditList(param).subscribe( list => {
            this.auditList = list ? list : [];
            this.auditList.forEach( item => {
              item['progress'] = item['progress'] ? this.util.accMul(item['progress'], 100) : '0';
              if (item.schedule) {
                item.schedule = JSON.parse(item.schedule);
              } else {
                item['schedule'] = {
                  schedulerDescription: item.lastExecuteTime ? this.util.timeFormat(item.lastExecuteTime) : this.taskDataDate
                };
              }
            });
          });
        }
      });
    } else {
      // 查询历史稽核日期
      this.taskService.getBoardPulseScanLog(this.pulse.id, this.taskDataDate).subscribe((res: any) => {
        if (res && res.scanParam) {
          const scanParam = JSON.parse(res.scanParam);
          const auditItemList = scanParam.auditItemList;
          if (auditItemList) {
            const param = {
              itemIdList: this.auditItemIdList,
              dataDate: auditItemList[0].dataDate
            };
            this.taskService.getAuditList(param).subscribe( list => {
              this.auditList = list ? list : [];
              this.auditList.forEach( item => {
                item['progress'] = item['progress'] ? this.util.accMul(item['progress'], 100) : '0';
                if (item.schedule) {
                  item.schedule = JSON.parse(item.schedule);
                } else {
                  item['schedule'] = {
                    schedulerDescription: item.lastExecuteTime ? this.util.timeFormat(item.lastExecuteTime) : this.taskDataDate
                  };
                }
              });
            });
          }
        }
      });
    }
  }
  // 获取监控项状态
  getIndicatorResult() {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      this.taskService.getRefreshTodayIndicatorDate({idList: this.monitorItemIdList.join(',')}).subscribe((res: any) => {
        let _date: any;
        if (res) {
          for (const i in res) {
            _date = res[i];
          }
          const param = {
            itemIdList: this.monitorItemIdList,
            dataDate: _date
          };
          this.taskService.getSupervisoryList(param).subscribe( list => {
            this.monitorList = list ? list : [];
            this.monitorList.forEach( item => {
              item['progress'] = item['progress'] ? this.util.accMul(item['progress'], 100) : '0';
              if (item.schedule) {
                item.schedule = JSON.parse(item.schedule);
              } else {
                item['schedule'] = {
                  schedulerDescription: item.lastExecuteTime ? this.util.timeFormat(item.lastExecuteTime) : this.taskDataDate
                };
              }
            });
          });
        }
      });
    } else {
      // 查询历史监控日期
      this.taskService.getBoardPulseScanLog(this.pulse.id, this.taskDataDate).subscribe((res: any) => {
        if (res && res.scanParam) {
          const scanParam = JSON.parse(res.scanParam);
          const indicatorItemList = scanParam.indicatorItemList;
          if (indicatorItemList) {
            const param = {
              itemIdList: this.monitorItemIdList,
              dataDate: indicatorItemList[0].dataDate
            };
            this.taskService.getSupervisoryList(param).subscribe( list => {
              this.monitorList = list ? list : [];
              this.monitorList.forEach( item => {
                item['progress'] = item['progress'] ? this.util.accMul(item['progress'], 100) : '0';
                if (item.schedule) {
                  item.schedule = JSON.parse(item.schedule);
                } else {
                  item['schedule'] = {
                    schedulerDescription: item.lastExecuteTime ? this.util.timeFormat(item.lastExecuteTime) : this.taskDataDate
                  };
                }
              });
            });
          }
        }
      });
    }
  }
  // 发送提醒
  sendWarned(type) {
    if (type === 'all') { // 发送全部
      this.ratioSuperisory.ids = [];
      this.ratioSuperisory.warnedComponent.ids = [];
      this.ratioSuperisory.warnedVisible = true;
      this.ratioSuperisory.initWarnedField();
      this.ratioSuperisory.warnedComponent.initWarned();
    } else { // 发送选择
      const ids = this.ratioSuperisory.getCheckedId();
      if (ids && ids.length) {
        this.ratioSuperisory.ids = ids;
        this.ratioSuperisory.warnedComponent.ids = ids;
        this.ratioSuperisory.warnedVisible = true;
        this.ratioSuperisory.initWarnedField();
        this.ratioSuperisory.warnedComponent.initWarned();
      }
    }
  }
  // 导出excel
  exportMonitorExcel() {
    this.ratioSuperisory.exportHandle();
  }
  getOutSystemName(outSystemCode) {
    return this.outSystems.hasOwnProperty(outSystemCode) ? this.outSystems[outSystemCode] : '';
  }
  // 报表预览
  reportPreview() {
    const date = this.taskDataDate.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1$2$3');
    const param = {
      reportId: this.taskReportConfig[0].reportId,
      dateValue: date,
      reportFormType: '1'
    };
    this.taskService.reportView(param).subscribe(result => {
      let url;
      const blob = new Blob([result], {type: 'application/pdf'});
      url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    });
  }
  // 报表导出
  reportExport() {
    const token = localStorage.getItem('id').split('Bearer ')[1];
    const date = this.taskDataDate.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1$2$3');
    const datasourceBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('datasourceModule') && SERVICE_CONFIG.environment['datasourceModule'] ? SERVICE_CONFIG.environment['datasourceModule'] : '';
    const url = datasourceBaseApi + '/v1/excel_report/export/' + this.taskReportConfig[0].reportId
      + '?reportFormType=1'
      + '&dateValue=' + date
      + '&jtoken=' +  token;
    window.open(url, '_blank');
  }
  checkReportCancle() {
    this.reportVisible = false;
  }
  // 获取扫描稽核进度
  getAuditProgress(auditId, latestExecutionId) {
    const _auditId = auditId;
    const _latestExecutionId = latestExecutionId;
    this.taskService.auditItemProgress(_auditId, _latestExecutionId).subscribe( res => {
      if (res) {
        this.currentAuditStatus = res['status'];
        if (res['status'] !== 'in_progress') {
          clearInterval(this.scanAuditTimer);
        }
      }
    });
  }
  stopScanAudit() {
    this.scanAuditStatus = false;
  }
  stopScanMonitor() {
    this.scanMonitorStatus = false;
  }
}
